//src/components/virtualization/virtualizedAutocomplete.js
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import ListboxComponent from "./listBoxComponent";
import { AutocompleteProps } from "@mui/material/Autocomplete";


const StyledListItem = styled("li")({
	// wordBreak: "break-word", // permite a quebra de linha para palavras longas
	// whiteSpace: "normal", // garante que o texto quebre em várias linhas
	// // padding: "8px", // padding interno para melhorar a aparência
	// listStyle: "none", // remove o estilo de lista
	// cursor: "pointer", // adiciona um cursor de ponteiro para indicar que é clicável
});

const VirtualizedAutocomplete = ({
	options,
	value,
	onChange,
	renderOption,
	renderInput,
	getOptionLabel,
	multiple = false,
	size = "small",
	fullWidth = false,
	loading = false,
	...props
}) => {
	const defaultGetOptionLabel = (option) =>
		typeof option === "string" ? option : option.name ?? "";

	const defaultRenderOption = (props, option, { index }) => (
		<StyledListItem {...props} data-index={index}>
			{typeof option === "string" ? option : option.name}
		</StyledListItem>
	);


	return (
		<Autocomplete
			options={options}
			value={value}
			loading={loading}
			onChange={onChange}
			ListboxComponent={ListboxComponent}
			multiple={multiple}
			size={size}
			fullWidth={fullWidth}
			getOptionLabel={getOptionLabel || defaultGetOptionLabel}
			renderOption={renderOption || defaultRenderOption}
			renderInput={
				renderInput ||
				((params) => <TextField {...params} color="primary" label="Item" />)
			}
			{...props}
		/>
	);
};

export default VirtualizedAutocomplete;
